import React, { useEffect, useMemo, useState } from 'react';
import { DialogUI, FormButtonPanelUI } from '../../Interface';
import Yup from '../../../utils/yup';
import { Form, Formik } from 'formik';
import ProjectAddDialogFields from './ProjectAddDialogFields';
import dayjs from 'dayjs';
import useUsers from '../../../context/UsersContext';
import projectService from '../../../service/project.service';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import useParam from '../../../context/ParamContext';
import { useProject } from '../../../hooks/useProject';
import { getDynVals } from '../../../utils/DynHelper';
import { cleanValues } from '../../../utils/helper';

const ProjectAddDialog = ({ open, handleClose, setRefetch, setValues, dynProps }) => {
  const projectState = useProject();
  const { getUser, user } = useUsers();
  const { getParam } = useParam();

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    getParam();
  }, []);

  const initialValues = useMemo(() => {
    const base = projectState.def;

    return {
      ...base,
      dynamicFields: getDynVals(dynProps, []),
    };
  }, [projectState.def, dynProps]);

  const validationSchema = Yup.object().shape({
    projectName: Yup.string().required(),
    orderNumber: Yup.string().nullable(),
    projectTypeId: Yup.string().nullable(),
  });

  const handleInsertObject = async (values) => {
    const insertObject = {
      ...cleanValues(values),
      projectPrepare: parseInt(values.projectPrepare),
      projectStartDate: dayjs(values.projectStartDate).startOf('day').add(12, 'hours').toISOString(),
      projectEndDate: dayjs(values.projectEndDate).startOf('day').add(12, 'hours').toISOString(),
      createdBy: user.userId,
      userId: user.userId,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(insertObject));

    if (insertObject.projectAttachment) {
      for (const file of insertObject.projectAttachment) {
        formData.append('files', file);
      }
    }

    projectService
      .createProject(formData)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });

        handleClose();
        setRefetch(true);
        setValues((prev) => ({
          ...prev,
          projectId: data.projectId,
        }));
      })
      .finally(() => {
        //@TODO loader
      });
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Projekt"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1200px',
          },
        },
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnChange={false}
        onSubmit={handleInsertObject}
        enableReinitialize
        //validateOnMount={false}
      >
        {({}) => (
          <Form>
            <ProjectAddDialogFields autoCompleteOptions={projectState.autoCompleteOptions} dynProps={dynProps} />

            <FormButtonPanelUI
              onCancelClick={() => {
                handleClose();
              }}
            />
          </Form>
        )}
      </Formik>
    </DialogUI>
  );
};

export default ProjectAddDialog;
